import { Box, Button } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import NamingSuggestionField from './NamingSuggestionField';

interface NamingSuggestionFinalProps {
  suggestedName: string;
  onAccept: (finalName: string) => void;
  onKeepOriginal: () => void;
  onBack?: () => void;
}

export default function NamingSuggestionFinal({
  suggestedName,
  onAccept,
  onKeepOriginal,
  onBack,
}: NamingSuggestionFinalProps): React.JSX.Element {
  const { t } = useTranslation(['common', 'products']);
  const [editedName, setEditedName] = useState(suggestedName);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <NamingSuggestionField suggestedName={suggestedName} value={editedName} onChange={setEditedName} />
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          gap: 1,
          flexDirection: { xs: 'column-reverse', sm: 'row' },
          justifyContent: 'flex-end',
          '& .MuiButton-root': { width: { xs: '100%', sm: 'auto' } },
        }}
      >
        {onBack && (
          <Button variant="outlined" onClick={onBack}>
            {t('common:previous')}
          </Button>
        )}
        <Button variant="outlined" onClick={onKeepOriginal}>
          {t('products:naming_wizard.keep_my_title')}
        </Button>
        <Button variant="contained" disabled={!editedName.trim()} onClick={() => onAccept(editedName)}>
          {t('products:name_optimization.validate')}
        </Button>
      </Box>
    </Box>
  );
}
